<template>  
	<div>
		<div class="dataTable-headre  d-flex align-items-center justify-content-between flex-end mb-3">
			<div class="rightSearch d-flex align-items-center justify-content-between">
				<!---------------------show-record-filter------------------------------>
				<div class="form-group parentClass-drop field-wrapper select-box-dropdown w-150 mb-0">
				<select class="float-field form-control" @change="pageLimitFunc()" v-model="pageLimit" v-if="pageLimitFilter != 'disable'">
					<option value="15">15</option>
					<option value="30">30</option>
					<option value="50">50</option>
				</select>
			    </div>
				<!--------------search------------------------------------------------->
				<div class="form-group parentClass has-search mx-2 mb-0 position-relative" v-if="searchFilter != 'disable'">
					
					<input type="text" class="form-control" placeholder="Search Here" v-model="search" >
					<feather type="search" class="form-control-feedback text-right" @click.prevent="searchFunc()"></feather>
				</div>
				
				<!-------------------WITHDRAWAL-COMMISSION-LISTING------------------------------------>
				<!--<div class="acceptHold inlineList" v-if="listStatusFilter == 'WITHDRAWAL-COMMISSION-LISTING'">
					<router-link  :to="(parseInt(get_user.verified_status ) == 1)?'/withdrawal':'/complete-steps'"  class="grd_btn btn-sm d-flex align-items-center">
					<feather class="mr-2 customSize" type="chevron-left"></feather>Create Withdrawal</router-link>  
				</div>-->
				<!-------------------Create-WITHDRAWAL------------------------------------>
				<!-- <div class="acceptHold inlineList" v-if="listStatusFilter == 'CREATE-WITHDRAWAL'">
					<router-link  :to="'/withdrawal-commission-list'"  class="grd_btn btn-sm d-flex align-items-center">
					<feather class="mr-2 customSize" type="chevron-left"></feather>back to  Withdrawal commission list</router-link>  
				</div> -->
				<!--------------------deposit-list------------------------------------->
				
				<div class="form-group field-wrapper select-box-dropdown mb-0" @change="depositModeFunc()" v-model="depositMode" v-if="(listStatusFilter == 'DEPOSIT-LISTING')">
				<select class="float-field form-control">
					<option value="">Select Deposit Method</option>
					<option :value="key" v-for="(list,key) in depositMethod">{{list}}</option>
				</select>
			    </div>
				
				
			</div> 
		</div>
		<ul class="topbar_tabs nav nav-tab mb-4 border-bottom" v-if="listStatusFilter == 'TRADING-ACCOUNTS-LISTING'">
			<li v-if="$parent.user_id == ''"><a :class="($parent.demo_live == '0')?'active' : ''" href="#" @click.prevent="showAccountList('0')"><span></span>Demo Accounts</a></li>
			<li><a  :class="($parent.demo_live == '1')?'active' : ''" href="#" @click.prevent="showAccountList('1')"><span></span>Live Accounts</a></li>
		</ul>
		<ul class="topbar_tabs nav nav-tab mb-4 border-bottom" v-if="listStatusFilter == 'WITHDRAWAL-LISTING' || listStatusFilter == 'WITHDRAWAL-COMMISSION-LISTING'">
			<li><a :class="($parent.listStatus == '')?'active' : ''" href="#" @click.prevent="withdrawalFilter('')"><span></span>All</a></li>
			<li><a  :class="($parent.listStatus == '0')?'active' : ''" href="#" @click.prevent="withdrawalFilter('0')"><span></span>Open</a></li>
			<li><a :class="($parent.listStatus == '1')?'active' : ''" href="#" @click.prevent="withdrawalFilter('1')"><span></span>Processed</a></li>
			<li><a  :class="($parent.listStatus == '2')?'active' : ''" href="#" @click.prevent="withdrawalFilter('2')"><span></span>Rejected</a></li>
		</ul>
		
		<ul class="topbar_tabs nav nav-tab mb-4 border-bottom" v-if="listStatusFilter == 'DEPOSIT-LISTING'">
			<li><a :class="($parent.listStatus == '')?'active' : ''" href="#" @click.prevent="depositFilter('')"><span></span>All</a></li>
			<li><a  :class="($parent.listStatus == '0')?'active' : ''" href="#" @click.prevent="depositFilter('0')"><span></span>Pending</a></li>
			<li><a :class="($parent.listStatus == '1')?'active' : ''" href="#" @click.prevent="depositFilter('1')"><span></span>Success</a></li>
		</ul>
		
	</div>
</template>
<script>   
	import { fxViewMixins } from '@/plugins/fxView'
	import moment from 'moment'
	export default{
	  name: 'FILTERS',
	  mixins: [fxViewMixins],
	  data(){
		return { 
			lang: {
				formatLocale: {
					firstDayOfWeek: 1,
				},
				monthBeforeYear: false,
			},
			toDateField : '',
			fromDateField : '',
			
			search : '',
			pageLimit : '15',
			delayTimer : null,
			//======================ticket-list==========================
			listStatus : '',
			ticket_Filter : '',
			//======================deposit-list==========================
			depositMode : '',
		}
	  },
	  props:['pageLimitFilter','searchFilter','listStatusFilter','showCreate'],
	  methods:{
		dateFormat(date){
			return moment(date).format('YYYY-DD-MM')
		},
		//======================ticket-list==========================
		listStatusFunc(){
			this.$parent.page = '1'
			this.$parent.listStatus = this.listStatus
			this.$parent.listing()
		},
		ticketFilterFunc(){
			this.$parent.ticket_Filter = this.ticket_Filter
			this.resetdata()
		},
		ticketStatusList(getData){
			this.$parent.ticket_status = getData
			this.resetdata()
		},
		//======================deposit-list==========================
		depositModeFunc(){
			this.$parent.page = '1'
			this.$parent.depositMode = this.depositMode
			this.$parent.listing()
		},
		depositFilter(getData){
			this.$parent.listStatus = getData
			this.resetdata()
		},
		//=====================withdrawal-list=======================
		withdrawalFilter(getData){
			this.$parent.listStatus = getData
			this.resetdata()
		},
		//=====================trading-list==========================
		showAccountList(getData){
			this.$parent.demo_live = getData
			this.resetdata()
		},
		//=====================reporting=============================
		reportStatusList(getData){
			this.$parent.report_status = getData
			this.resetdata()
		},
		//=====================common=================================
		resetdata(){
			this.$parent.page = '1'
			this.$parent.search = ''
			this.$parent.pageLimit = '15'
			this.search = this.$parent.search
			this.pageLimit = this.$parent.pageLimit
			this.$parent.listing()
		},
		pageLimitFunc(){
			this.$parent.pageLimit = this.pageLimit
			this.$parent.listing()
		},
		searchFunc(){
			this.$parent.page = '1'
			this.$parent.search = this.search
			this.$parent.listing()
			
		}
	  }
	}
</script>



// WEBPACK FOOTER //
// src/components/fxView/shared/top_header_title.vue